import { Link } from 'react-router-dom';
import styles from './PublicFooter.module.css';

const PublicFooter = () => {
  return (
    <footer className={styles.publicFooter}>
      <span>© 2025 SoulstoreAI LLC. All Rights Reserved.</span>
      <div className={styles.footerLinks}>
        <Link to="/faq">FAQ</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/privacy">Privacy Policy</Link>
      </div>
    </footer>
  );
};

export default PublicFooter;
